import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gridColumnData'
})
export class GridColumnDataPipe implements PipeTransform {

  transform(row: any, selector: string): any {
    let value = null;
    const multiSelectors = selector.split('.');

    if (multiSelectors.length > 1) {
      let actualValue = row;
      for (const select0r of multiSelectors) {
        actualValue = actualValue[select0r];
      }
      value = actualValue;
    } else {
      value = row[selector];
    }

    if (typeof value === 'number') {
      return value.toFixed(2);
    } else if (typeof value === 'string' && !value.includes(' ') && Date.parse(value)) {
      return new Date(value).toLocaleDateString();
    } else {
      return value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/custom-grid/grid-column-data.pipe.ts